import React from "react";
import { NavLink } from 'react-router-dom';
import { FaLink, FaRegFilePdf } from "react-icons/fa"


import './IntroPage.css'



import file_Satzung from '../shared/documents/combat_sports_satzung.pdf'
import file_Beitritt from '../shared/documents/combat_sports_beitrittserklärung.pdf'


const Downloads = function (props) {

    const files = {
        satzung: { name: 'combat_sports_satzung', url: file_Satzung },
        mitgliedsbeitrag: { name: 'combat_sports_beitritt', url: file_Beitritt },
    };


    return (

        <React.Fragment>







            <div className="page-body page-body-first-element" >
                <div className="page-content">
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Dokumente</span></h2>
                            <p>
                                Hier findest Du alle wichtigen Dokumente und Unterlagen für unseren Sportverein. Mitgliedsanträge, die Vereinssatzung und mehr stehen zum Download bereit. Bei Fragen melde dich gerne bei uns!

                            </p>
                            <p>
                                <NavLink className="underline cs-text-link" to="/impressum" exact="true"><FaLink className="icon-link-text " /> Impressum</NavLink>
                            </p>
                        </div>
                    </div>
                    <br></br>
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Vereinssatzung</span></h2>
                            <p>
                                In unserer Vereinssatzung sind die Grundprinzipien und Regeln festgehalten, die unsere Gemeinschaft formen. Sie schafft Klarheit darüber, wie wir zusammenarbeiten, Entscheidungen treffen und das Beste für unsere Mitglieder erreichen. Hier kannst Du die Grundlagen unseres Vereinslebens nachlesen.
                            </p>
                            <div class="download-link">
                                <a class="download-link-text" href={files?.satzung?.url} download={files?.satzung?.name} ><div><FaRegFilePdf className="download-icon-link " /> Download Vereinssatzung</div></a>
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <div className="container-box">
                        <div className="intro-content">
                            <h2 className="intro-name"><span>Beitrittserklärung</span></h2>
                            <p>
                                Haben wir dein Interesse geweckt? Die Abbuchung erfolgt quartalsweise und zusätzlich zum regulären Beitrag wird ein Pfand für den Transponder fällig. So bleibt alles klar und transparent, während wir gemeinsam unsere sportlichen Ziele verfolgen. Willkommen an Bord!
                            </p>
                            <div class="download-link">
                                <a class="download-link-text" href={files?.mitgliedsbeitrag?.url} download={files?.mitgliedsbeitrag?.name} ><div><FaRegFilePdf className="download-icon-link " /> Download Beitrittserklärung</div></a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>







            {/* <div className="page-body">
                <div className="page-content">
                    <div className="promo" >
                        <div className="image-wrapper"><img src="https://images.unsplash.com/photo-1554620121-59e7f3f6e3a4?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ" /></div>
                        <h2 className="title" data-cta="Get out there TEST TEST→">Nightlife</h2>
                    </div>
                </div >
            </div > */}


            {/* <div className="page-body">
                <div className="page-content">

                    <IntroDescriptionTwo />

                </div>

            </div> */}








        </React.Fragment >
    )
}

export default Downloads